import { object, picklist } from "valibot";

export const ThemeFormSchema = object({
  theme: picklist(["system", "light", "dark"]),
});
